import axios from 'axios';
import { authService } from '@/services/auth.service';
import { handleCognitoError, refreshTokenCognito } from '../cognito.service';
const request = axios.create();

let isRefreshing = false;
let refreshSubscribers = [];
request.interceptors.request.use(
  async function (config) {
    if (!navigator.onLine) {
      // if offline reject request
      return Promise.reject(new Error('No internet connection'));
    }
    if (!window.cognitoTokenInterval) {
      window.cognitoTokenInterval = window.setInterval(
        // Refresh token every 50 minutes
        () =>
          refreshTokenCognito
            .then(({ error }) => {
              if (error) {
                throw error;
              }
            })
            .catch((error) => handleCognitoError(error)),
        3000000
      );
    }
    const idToken = await authService.getIdToken();
    if (idToken) {
      config.headers.Authorization = 'Bearer ' + idToken;
    }
    return config;
  },
  function (error) {
    clearInterval(window.cognitoTokenInterval);
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    let { config } = err;
    const originalRequest = config;
    return authService.getCurrentCognitoSession().then((session) => {
      var idTokenExpire = session.getIdToken().getExpiration();
      var currentTime = Math.round(+new Date() / 1000);
      if (
        (idTokenExpire < currentTime || err?.response?.status === 401) &&
        !originalRequest._retry
      ) {
        if (isRefreshing) {
          return new Promise(function (resolve, reject) {
            refreshSubscribers.push({ resolve, reject });
          })
            .then((token) => {
              originalRequest.headers['Authorization'] = 'Bearer ' + token;
              return axios(originalRequest);
            })
            .catch((err) => {
              return Promise.reject(err);
            });
        }

        originalRequest._retry = true;
        isRefreshing = true;

        return new Promise(function (resolve, reject) {
          refreshTokenCognito()
            .then((result) => {
              const { error, token } = result;
              const error401 = new Error(401);
              if (error) {
                // error on refresh token
                console.error(error);
                processQueue(error401, null);
                reject(error401);
              }
              if (!token) {
                // user is not logged-in
                console.error('User in not logged-in');
                processQueue(error401, null);
                reject(error401);
              }
              originalRequest.headers['Authorization'] = 'Bearer ' + token;
              processQueue(null, token);
              resolve(axios(originalRequest));
            })
            .catch((err) => {
              processQueue(err, null);
              reject(err);
            })
            .finally(() => {
              isRefreshing = false;
            });
        });
      }
      return Promise.reject(err);
    });
  }
);

const processQueue = (error, token = null) => {
  refreshSubscribers.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  refreshSubscribers = [];
};
export default request;
